import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MobileLayout from './MobileLayout';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { CustomerServiceRoute } from '@/components/routing/CustomerServiceRoute';

const MobileHome = lazy(() => import('./MobileHome'));
const MobileDashboard = lazy(() => import('./desktop/MobileDashboardScreen'));
const MobileLeads = lazy(() => import('./desktop/MobileLeadsScreen'));
const MobileLeadDetail = lazy(() => import('./desktop/MobileLeadDetailScreen'));
const MobileContacts = lazy(() => import('./MobileContacts'));
const MobileContactDetail = lazy(() => import('./MobileContactDetail'));
const MobileDeals = lazy(() => import('./MobileDeals'));
const MobileDealDetail = lazy(() => import('./MobileDealDetail'));
const MobileWhatsApp = lazy(() => import('./MobileWhatsApp'));
const MobileTasks = lazy(() => import('./MobileTasks'));
const MobileCalls = lazy(() => import('./MobileCalls'));
const MobileProfile = lazy(() => import('./MobileProfile'));
const MobileCases = lazy(() => import('./MobileCases'));
const MobileCaseDetail = lazy(() => import('./MobileCaseDetail'));
const MobileCustomerService = lazy(() => import('./MobileCustomerService'));
const MobileKnowledgeBase = lazy(() => import('./desktop/MobileKnowledgeBaseScreen'));
const MobileReports = lazy(() => import('./desktop/MobileReportsScreen'));
const MobileSalesReport = lazy(() => import('./desktop/MobileSalesReportScreen'));
const MobileCommissionReport = lazy(() => import('./desktop/MobileCommissionReportScreen'));
const MobileOnboarding = lazy(() => import('./desktop/MobileOnboardingScreen'));
const MobileOnboardingDetail = lazy(() => import('./desktop/MobileOnboardingDetailScreen'));
const MobileAnnouncements = lazy(() => import('./desktop/MobileAnnouncementsScreen'));
const MobileServiceDetail = lazy(() => import('./desktop/MobileServiceDetailScreen'));

function MobileFallback() {
  return <div className="p-3 text-sm text-muted-foreground">Carregando...</div>;
}

function MobileErrorFallback() {
  return (
    <div className="p-3">
      <p className="text-sm text-destructive">Erro ao carregar a tela mobile.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-2 rounded-md border px-3 py-2 text-sm"
      >
        Recarregar
      </button>
    </div>
  );
}

export default function MobileRoutes() {
  return (
    <ErrorBoundary fallback={<MobileErrorFallback />}>
      <Routes>
        <Route element={<MobileLayout />}>
          <Route path="/" element={<Suspense fallback={<MobileFallback />}><MobileHome /></Suspense>} />
          <Route path="/dashboard" element={<Suspense fallback={<MobileFallback />}><MobileDashboard /></Suspense>} />
          <Route path="/leads" element={<Suspense fallback={<MobileFallback />}><MobileLeads /></Suspense>} />
          <Route path="/leads/:id" element={<Suspense fallback={<MobileFallback />}><MobileLeadDetail /></Suspense>} />
          <Route path="/contacts" element={<Suspense fallback={<MobileFallback />}><MobileContacts /></Suspense>} />
          <Route path="/contacts/:id" element={<Suspense fallback={<MobileFallback />}><MobileContactDetail /></Suspense>} />
          <Route path="/deals" element={<Suspense fallback={<MobileFallback />}><MobileDeals /></Suspense>} />
          <Route path="/deals/:id" element={<Suspense fallback={<MobileFallback />}><MobileDealDetail /></Suspense>} />
          <Route path="/whatsapp" element={<Suspense fallback={<MobileFallback />}><MobileWhatsApp /></Suspense>} />
          <Route path="/whatsapp/:id" element={<Suspense fallback={<MobileFallback />}><MobileWhatsApp /></Suspense>} />
          <Route path="/tasks" element={<Suspense fallback={<MobileFallback />}><MobileTasks /></Suspense>} />
          <Route path="/calls" element={<Suspense fallback={<MobileFallback />}><MobileCalls /></Suspense>} />
          <Route path="/profile" element={<Suspense fallback={<MobileFallback />}><MobileProfile /></Suspense>} />
          <Route path="/cases" element={<Suspense fallback={<MobileFallback />}><MobileCases /></Suspense>} />
          <Route path="/cases/:id" element={<Suspense fallback={<MobileFallback />}><MobileCaseDetail /></Suspense>} />
          <Route path="/customer-service" element={<CustomerServiceRoute><Suspense fallback={<MobileFallback />}><MobileCustomerService /></Suspense></CustomerServiceRoute>} />
          <Route path="/knowledge-base" element={<Suspense fallback={<MobileFallback />}><MobileKnowledgeBase /></Suspense>} />
          <Route path="/reports" element={<Suspense fallback={<MobileFallback />}><MobileReports /></Suspense>} />
          <Route path="/reports/sales-report" element={<Suspense fallback={<MobileFallback />}><MobileSalesReport /></Suspense>} />
          <Route path="/reports/commission-report" element={<Suspense fallback={<MobileFallback />}><MobileCommissionReport /></Suspense>} />
          <Route path="/onboarding" element={<Suspense fallback={<MobileFallback />}><MobileOnboarding /></Suspense>} />
          <Route path="/onboarding/detail" element={<Suspense fallback={<MobileFallback />}><MobileOnboardingDetail /></Suspense>} />
          <Route path="/announcements" element={<Suspense fallback={<MobileFallback />}><MobileAnnouncements /></Suspense>} />
          <Route path="/service-detail" element={<Suspense fallback={<MobileFallback />}><MobileServiceDetail /></Suspense>} />
          <Route path="*" element={<Navigate to="/m/" replace />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
